import gql from 'graphql-tag';

export const carFragments = gql`
  fragment carFragments on Car {
    id
    name
    norwegianListPriceAsNew
    registrationNumber
  }
`;

export const ALL_CARS = gql`
  query currentUnitCars {
    currentUnit {
      id
      cars {
        ...carFragments
      }
    }
  },
  ${carFragments}
`;

